import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ReportGetPreviewById, ReportGetPreviewResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<ReportGetPreviewResponse, ReportGetPreviewResponse>) => {
    return response?.data;
}
const getError = (response?: SWRResponse<ReportGetPreviewResponse, ReportGetPreviewResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => ({});

const useReportPreviewById = (reportId?: number, configuration?: SWRConfiguration<ReportGetPreviewResponse, ReportGetPreviewResponse>) => {
    const request = useMemo(() => {
        if(!reportId) return undefined;

        return () => new ReportGetPreviewById({
            reportId: reportId
        });
    }, [reportId]);

    return useGet(request, { getData, getError }, configuration);
}

export default useReportPreviewById;